import { render, staticRenderFns } from "./c-scroll-pro.vue?vue&type=template&id=0924466e&scoped=true"
import script from "./c-scroll-pro.vue?vue&type=script&lang=js"
export * from "./c-scroll-pro.vue?vue&type=script&lang=js"
import style0 from "./c-scroll-pro.vue?vue&type=style&index=0&id=0924466e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0924466e",
  null
  
)

export default component.exports